import { Button } from '~/components/button'
import type { PaginationControlProps } from '../../pagination.types'

export const PaginationControl: React.FC<PaginationControlProps> = ({
  control,
  children,
  disabled,
  testID,
  ...props
}) => {
  return (
    <a
      data-testid={testID}
      {...props}
      aria-disabled={disabled}
      href={control?.href}
    >
      <Button.Root
        type="button"
        disabled={disabled}
        variant="neutral-secondary"
        size="lg"
        onClick={control?.onClickEvent}
      >
        {children}
      </Button.Root>
    </a>
  )
}
